import { render, staticRenderFns } from "./EventPage.vue?vue&type=template&id=61ebc76c"
import script from "./EventPage.vue?vue&type=script&lang=js"
export * from "./EventPage.vue?vue&type=script&lang=js"
import style0 from "./EventPage.vue?vue&type=style&index=0&id=61ebc76c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports